import { render, staticRenderFns } from "./LicenseConfig.vue?vue&type=template&id=5b486f80"
import script from "./LicenseConfig.vue?vue&type=script&lang=js"
export * from "./LicenseConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports